import * as ACTIONCONTANTS from './ActionConstants';
import { ApiRequest } from "../../utilities/ApiRequest";
import { IApi, Api } from "../../utilities/Api";
import LMSDispatcher from "../LMSDispatcher";
import IPropertyType, { PropertyTypeData } from '../../models/propertyType/PropertyTypeData';
import notificationActions from './NotificationActions';
import i18next from 'i18next';

class PropertyTypeActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }
    
    async getAll() {
        try {
            const request = new ApiRequest("/propertytype", "", null, i18next.t("Failed to fetch property types"));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.PROPERTY_TYPE_GET_ALL,
                payload: {
                    propertyTypeData: payload
                }
            });
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
              }).then();
        }
    }
    convertResponseData(data: any): IPropertyType {
        return new PropertyTypeData(data.id, data.name);
    }

    private convertResponseListData(data: any): IPropertyType[] {
        const result: IPropertyType[] = [];

        data.forEach((element: { id: string; name: string; }) => {
            result.push(this.convertResponseData(element));
        });
        return result;
    }
}

const propertyTypeActions = new PropertyTypeActions();
export default propertyTypeActions;